(function () {
  if (!$(".js-video-collection-page").length) return;
  if ($().chosen) {
    $(".chosen-select").chosen({
      disable_search_threshold: 5,
      no_results_text: $(".js-no-results-text").val(),
    });
  }

  const { translations, lang } = _video_data;

  const INITIAL_FILTERS = {
    topics: [],
    authors: [],
    tags: [],
    search: "",
    order: "DESC",
  };

  let filters = JSON.parse(JSON.stringify(INITIAL_FILTERS));

  const videos_url = $("[data-video-url]").data("video-url");

  function buildTag(label, topic, type) {
    return `
     <div>${label}: <span>${topic.name}</span>
      <button data-id="${topic.term_id}" data-type="${type}">
        <div></div>
        <div></div>
      </button>
     </div>
    `;
  }

  function buildTags() {
    let html = "";
    filters.topics.forEach((t) => {
      const topic = _video_data.topics.find((term) => term.term_id == t);
      html += buildTag(translations.topic, topic, "topics");
    });
    filters.authors.forEach((t) => {
      const author = _video_data.authors.find((term) => term.term_id == t);
      html += buildTag(translations.author, author, "authors");
    });
    filters.tags.forEach((t) => {
      const tag = _video_data.tags.find((term) => term.term_id == t);
      html += buildTag(translations.tag, tag, "tags");
    });
    $(".js-video-badges").html(html);
  }

  $(document).on("click", ".js-video-badges button", function (e) {
    e.preventDefault();
    const id = $(this).data("id");
    const type = $(this).data("type");
    filters[type] = filters[type].filter((item) => item != id);
    $(this).parent().remove();
    updateUrl();
    buildTags();
    updateCollection();
  });

  $(document).on("click", ".js-load-more-videos", function (e) {
    e.preventDefault();
    const offset = $(`.js-video-collection-row > div`).length;
    $(".js-video-collection-loader").fadeIn();
    $.ajax({
      method: "get",
      url: videos_url,
      data: {
        ...filters,
        action: "load_more_videos",
        offset,
        lang,
      },
      success: function (res) {
        $(`.js-video-collection-row`).append(res.html);
        $(".lazy").Lazy();
        if (!res.has_more) {
          $(`.js-video-collection-row`)
            .parents(".js-video-collection-section")
            .find(".video__collection__more")
            .remove();
        }
        $(".js-video-collection-loader").fadeOut();
      },
      error: function () {
        alert("Atsiprašome, įvyko klaida...");
        $(".js-video-collection-loader").fadeOut();
      },
    });
  });

  function updateCollection() {
    $(".js-video-collection-loader").fadeIn();
    $.ajax({
      method: "get",
      url: videos_url,
      data: {
        ...filters,
        lang,
        action: "video_filter",
      },
      dataType: "json",
      contentType: "application/json",
      success: function (res) {
        $(".js-video-collection").html(res.html);
        $(".lazy").Lazy();
        $(".js-video-collection-loader").fadeOut();
      },
      error: function () {
        alert("Atsiprašome, įvyko klaida...");
        $(".js-video-collection-loader").fadeOut();
      },
    });
  }
  function updateUrl() {
    const url = new URL(
      location.protocol + "//" + location.host + location.pathname
    );
    const params = url.searchParams;
    if (filters.search) {
      params.append("search", filters.search);
    }
    params.append("order", filters.order);
    filters.topics.forEach((t) => {
      params.append("topics", t);
    });
    filters.authors.forEach((t) => {
      params.append("authors", t);
    });
    filters.tags.forEach((t) => {
      params.append("tags", t);
    });
    window.history.replaceState(null, null, url);
  }

  $(".js-video-filter[data-type='order']").change(function (e) {
    e.preventDefault();
    filters.order = e.target.value;
    updateUrl();
    buildTags();
    updateCollection();
  });
  $(".js-video-filter[data-type='multiple']").change(function (e) {
    e.preventDefault();
    if (filters[e.target.name].find((item) => item == e.target.value)) {
      $(this).val("");
      return $(this).trigger("chosen:updated");
    }
    filters[e.target.name].push(e.target.value);
    filters.search = "";
    $(".js-video-search-filter").val("");
    $(this).val("");
    $(this).trigger("chosen:updated");
    updateUrl();
    buildTags();
    updateCollection();
  });
  $(".js-video-search-filter").change(function (e) {
    filters = JSON.parse(JSON.stringify(INITIAL_FILTERS));
    filters.search = e.target.value;
    updateUrl();
    buildTags();
    updateCollection();
  });

  $(document).on("click", ".js-video-modal-close", function (e) {
    e.preventDefault();
    updateUrl();
    $(".js-video-modal").fadeOut();
  });

  $(document).on("click", ".js-video-link", function (e) {
    e.preventDefault();
    $(".js-video-collection-loader").fadeIn();
    const slug = $(this).data("slug");
    const url = new URL(
      location.protocol + "//" + location.host + location.pathname
    );
    url.hash = slug;
    window.history.replaceState(null, null, url);
    const $prev = $(
      `.js-video-link.video__collection__item[data-slug="${slug}"]`
    )
      .parents(".col-2.col-md-4.col-xs-6")
      .prev();
    const $next = $(
      `.js-video-link.video__collection__item[data-slug="${slug}"]`
    )
      .parents(".col-2.col-md-4.col-xs-6")
      .next();

    $.ajax({
      method: "get",
      url: videos_url,
      data: {
        action: "video_modal",
        slug,
      },
      dataType: "json",
      contentType: "application/json",
      success: function (res) {
        $(".js-video-modal > div").html(res.html);
        if ($prev.length) {
          const prevSlug = $prev.find("> a").data("slug");
          $(".js-video-modal .js-video-link-prev")
            .data("slug", prevSlug)
            .show();
        }
        if ($next.length) {
          const nextSlug = $next.find("> a").data("slug");
          $(".js-video-modal .js-video-link-next")
            .data("slug", nextSlug)
            .show();
        }
        $(".js-video-modal").fadeIn();
        $(".js-video-collection-loader").fadeOut();
      },
      error: function () {
        alert("Atsiprašome, įvyko klaida...");
        $(".js-video-collection-loader").fadeOut();
      },
    });
  });

  (function () {
    const url = new URL(document.location);
    if (!url.search) return;
    const params = url.searchParams;
    filters.topics = params.getAll("topics");
    filters.authors = params.getAll("authors");
    filters.tags = params.getAll("tags");
    filters.order = params.get("order") || "DESC";
    filters.search = params.get("search") || "";
    updateCollection();
    buildTags();
  })();

  if (window.location.hash) {
    $(".js-video-collection-loader").fadeIn();
    const slug = window.location.hash.replace("#", "");
    $.ajax({
      method: "get",
      url: videos_url,
      data: {
        action: "video_modal",
        slug,
      },
      dataType: "json",
      contentType: "application/json",
      success: function (res) {
        $(".js-video-modal > div").html(res.html);
        $(".js-video-modal").fadeIn();
        $(".js-video-collection-loader").fadeOut();
      },
      error: function () {
        alert("Atsiprašome, įvyko klaida...");
        $(".js-video-collection-loader").fadeOut();
      },
    });
  }
})();
